import React from 'react';
import footerLogo from 'assets/images/logos/rootstoken__white.png';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import config from 'config';
const menuItems = [
    {
        name: 'Feature',
        url: '#',
    },
    {
        name: 'Pricing',
        url: '#',
    },

    {
        name: 'Community',
        url: '#',
    },
];

const menuSocial = [
    {
        name: 'Facebook',
        icon: <FaFacebookF />,
        url: 'https://www.facebook.com/ROOTSTOKEN/',
    },
    {
        name: 'Instagram',
        icon: <FaInstagram />,
        url: 'https://www.instagram.com/rootstoken',
    },
    // {
    //     icon: <FaTiktok />,
    //     url: 'https://www.tiktok.com/@rootstoken0?_t=ZM-8tJT4lNOebW&_r=1',
    // },
    {
        name: 'Whatsapp',
        icon: <FaWhatsapp />,
        url: 'https://wa.me/5215629933625',
    },
];
export default function MainFooter() {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="nv__footer">
            <section className="nv__section nv__section--no-margin">
                <section className="nv__section__container">
                    <div className="nv__footer__block nv__footer__block--no-flex">
                        <div className="nv__footer__logo">
                            <img src={footerLogo} alt="logo" />
                        </div>
                        {/* <p>© {currentYear} RootsToken.</p> */}
                    </div>
                    <div className="nv__footer__block nv__footer__block--menu">
                        {/* <ul className="nv__footer__menu">
                            {menuItems.map((item) => {
                                return (
                                    <li key={item.name}>
                                        <Link className="nv__link__menu" to={item.url}>
                                            {' '}
                                            {t(item.name)}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul> */}
                    </div>
                    <div className="nv__footer__block nv__footer__block">
                        <ul className="nv__footer__social">
                            {menuSocial.map((item) => {
                                return (
                                    <li key={item.name}>
                                        <Link to={item.url} target="_blank">
                                            {' '}
                                            {item.icon}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </section>
            </section>
        </footer>
    );
}
